const PRETTY_INDENT = 2;

export type ReformatResult =
  | { ok: true; formatted: string; changed: boolean }
  | { ok: false };

/**
 * Parse a JSON string and return its 2-space pretty-printed form.
 * `changed` tells the caller whether the reformatted value differs from the input,
 * so it can skip a no-op onChange dispatch.
 * Returns `{ ok: false }` for strings that aren't valid JSON — the caller decides
 * how to surface the error (localized message, styling, etc).
 */
export const reformatJsonString = (value: string): ReformatResult => {
  try {
    const parsed = JSON.parse(value);
    const formatted = JSON.stringify(parsed, null, PRETTY_INDENT);
    return { ok: true, formatted, changed: formatted !== value };
  } catch {
    return { ok: false };
  }
};
